// extracted by mini-css-extract-plugin
module.exports = {"type":"Sitemap_type_1bbht","table":"Sitemap_table_1q9xl"};